export default function exportExcel(array, name, merges) {
	debugger
	name += new Date().toLocaleString()
	let workbook = window.XLSX.utils.book_new();
	let sheet = window.XLSX.utils.aoa_to_sheet(array);

	sheet['!merges'] = merges
	window.XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
	window.XLSX.writeFile(workbook, name + '.xls'); //导出Excel
}